export default "__VITE_ASSET__EQ2Uhm1P__"